import { Card } from "@devhop/ui";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";
import { formatDateLocal } from "@/shared/lib/date-time";

type ChecklistResultTrendProps = {
  stats: ChecklistResultStatsResult;
};

export function ChecklistResultTrend({ stats }: ChecklistResultTrendProps) {
  if (stats.byDate.length === 0) return null;

  return (
    <Card className="gap-0 p-6">
      <h2 className="mb-4 font-semibold text-lg">ແນວໂນ້ມຕາມວັນທີ (ເລີ່ມບັນທຶກ)</h2>
      <div className="space-y-2">
        {stats.byDate.slice(0, 10).map((day) => {
          const t = day.total || 1;
          return (
            <div key={day.date}>
              <div className="mb-1 flex flex-wrap items-center justify-between gap-2 text-sm">
                <span>{formatDateLocal(day.date)}</span>
                <span className="text-muted-foreground">
                  ສຳເລັດ {day.completed} · ກຳລັງເຮັດ {day.inProgress} · ຍົກເລີກ{" "}
                  {day.cancelled} · ທັງໝົດ {day.total}
                </span>
              </div>
              <div className="flex h-3 gap-px overflow-hidden rounded bg-muted">
                <div
                  className="bg-green-500"
                  style={{ width: `${(day.completed / t) * 100}%` }}
                />
                <div
                  className="bg-amber-500"
                  style={{ width: `${(day.inProgress / t) * 100}%` }}
                />
                <div
                  className="bg-muted-foreground/50"
                  style={{ width: `${(day.cancelled / t) * 100}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
